import React, { useState } from "react";

import { Paper, Grid, Typography, Toolbar, Box } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import ShipmentNewGrid from "Components/AppGrid/shipeezi-new-grid";
import { AxiosResponse } from "axios";
import classnames from "classnames";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";

import { useAppState } from "../../../../context/StateContext";
import { WidgetProps } from "../../../../models/shipment.tracking";
import DashboardService, {
  DashboardTrackedDelayRaking,
} from "../../../../services/dashboard.service";
import NoDataLabel from "../../NoDataLabel/index";
import { useStyles } from "./styles";
import "./tableHeader.css";

/** Default Functional Component */
export default function AverageDelay({ widgetFilter }: WidgetProps) {
  const classes = useStyles();
  const { t: translate } = useTranslation();
  const { currentUser } = useAppState();

  const [data, setData] = useState<DashboardTrackedDelayRaking[]>([]);

  useQuery(
    ["dashboard.average.delay.list"],
    () =>
      DashboardService.getContainerAverageDelayList({
        dateFrom: widgetFilter?.dateFrom,
        dateTo: widgetFilter?.dateTo,
        companyId: currentUser?.companyId,
      }),
    {
      onSuccess: (response: AxiosResponse<DashboardTrackedDelayRaking[]>) => {
        if (response && response.data) {
          setData(response.data);
        }
      },
    }
  );

  return (
    <>
      <Grid data-cy="averageDelayBox" item md={6} sm={12} xs={12}>
        <Paper className={classes.root}>
          <Toolbar className={classes.tblRoot} variant="dense">
            <Typography className={classes.title} color="textSecondary" data-cy="averageDelayTitle">
              {translate("averageDelay")}
            </Typography>
            <Box className={classes.bxFlexGrow} />
          </Toolbar>
          {data.length === 0 ? (
            <NoDataLabel />
          ) : (
            <div className={classnames("chart-container", classes.quotesPerformedWrapStyles)}>
              <ShipmentNewGrid
                data={data}
                columns={[
                  { name: "containerId", title: `${translate("container")} #`, hideSort: true },
                  {
                    name: "delayTime",
                    title: `${translate("delayTime")}`,
                    hideSort: true,
                    formatText: (days: string) => {
                      if (Number(days) > 1) return `${days} ${translate("days").toLowerCase()}`;

                      return `${days} ${translate("day").toLowerCase()}`;
                    },
                  },
                  {
                    name: "newETA",
                    title: translate("newETA"),
                    formatText: (date: Date) => format(new Date(date), "dd/MM/yyyy"),
                    hideSort: true,
                  },
                ]}
                showSelection={false}
              />
            </div>
          )}
        </Paper>
      </Grid>
    </>
  );
}
